/** @file This file contains utilities to works with Vue props. */
import moment from 'moment';
import p from 'vue-strict-prop';
/** A prop for a required duration. */
export const durationProp = p
    .ofType()
    .validator(d => moment.isDuration(d) && d.isValid()).required;
/** All options for what to do with inline feedback. */
export const SHOW_INLINE_FEEDBACKS = Object.freeze([
    'all',
    'only-normal',
    'only-peer',
    'none',
]);
/** A prop for how to show inline feedback. */
export const showInlineFeedbackProp = p.ofStringLiterals(...SHOW_INLINE_FEEDBACKS).default('all');
